import React from 'react';
import Select from '../../../engine/SelectEngine';
import { SimpleFlexContainer } from '../../../layouts/ng-layouts/Containers';
import styled from 'styled-components';
import useTranslations from '../../../../hooks/useTranslations';
import { Divider as MuiDivider, IconButton, Tooltip } from '@material-ui/core';
import SubjectIcon from '@material-ui/icons/Subject';
import Animation from '../../../Animation';
import UsersInputBoxEngine from '../../../engine/UsersInputBoxEngine';
import Colors from '../../../../internal-components/Colors';
import EmailDialogEngine, {
  EMAIL_DIALOG_TYPES
} from '../../../engine/EmailDialogEngine';
import Labeler from '../../../Labeler';
import Disabler from '../../../Disabler';
import UserLookupFieldSelectEngine from '../engine/UserLookupFieldSelectEngine';

const Container = styled(SimpleFlexContainer)`
  margin-left: 0.8rem;
  width: 40rem;
`;

const UsersSelectContainer = styled.span`
  transition: 0.4s;
  margin: auto 0;
  flex: 1;
`;

const userSelectCSS = `
    & > div {
        border-color: ${Colors.BORDER_GREY};
        border-radius: 6px;
        min-height: 36px !important;
    }
`;
const EditTemplateBtnContainer = styled.span`
  margin-left: 0.8rem;
  line-height: 3;
`;

const WideSpan = styled.span`
  width: 100%;
`;

const Divider = styled(MuiDivider)`
  margin: 0.4rem 0 0.8rem !important;
`;

const EditEmailIcon = styled(SubjectIcon)`
  && {
    /* ----------------------------------------------
    * Generated by Animista on 2021-12-9 15:38:12
    * Licensed under FreeBSD License.
    * See http://animista.net/license for more info. 
    * w: http://animista.net, t: @cssanimista
    * ---------------------------------------------- */

    /**
    * ----------------------------------------
    * animation shake-lr
    * ----------------------------------------
    */
    @-webkit-keyframes shake-lr {
      0%,
      100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
      }
      10% {
        -webkit-transform: rotate(8deg);
        transform: rotate(8deg);
        color: ${Colors.PRIMARY};
      }
      20%,
      40%,
      60% {
        -webkit-transform: rotate(-10deg);
        transform: rotate(-10deg);
        color: ${Colors.PRIMARY};
      }
      30%,
      50%,
      70% {
        -webkit-transform: rotate(10deg);
        transform: rotate(10deg);
        color: ${Colors.PRIMARY};
      }
      80% {
        -webkit-transform: rotate(-8deg);
        transform: rotate(-8deg);
        color: ${Colors.PRIMARY};
      }
      90% {
        -webkit-transform: rotate(8deg);
        transform: rotate(8deg);
      }
    }
    @keyframes shake-lr {
      0%,
      100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
      }
      10% {
        -webkit-transform: rotate(8deg);
        transform: rotate(8deg);
        color: ${Colors.PRIMARY};
      }
      20%,
      40%,
      60% {
        -webkit-transform: rotate(-10deg);
        transform: rotate(-10deg);
        color: ${Colors.PRIMARY};
      }
      30%,
      50%,
      70% {
        -webkit-transform: rotate(10deg);
        transform: rotate(10deg);
        color: ${Colors.PRIMARY};
      }
      80% {
        -webkit-transform: rotate(-8deg);
        transform: rotate(-8deg);
        color: ${Colors.PRIMARY};
      }
      90% {
        -webkit-transform: rotate(8deg);
        transform: rotate(8deg);
      }
    }
    transition: 0.3s;

    ${({ $playAnimation }) =>
      $playAnimation &&
      `-webkit-animation: shake-lr 0.7s cubic-bezier(0.455, 0.03, 0.515, 0.955)
    both;
  animation: shake-lr 0.7s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;`}
  }
`;

const StyledTextString = styled.div`
  font-style: italic;
  font-weight: bold;
  font-size: 12px;
`;

const EmailConfView = props => {
  const t = useTranslations();
  return (
    <Container>
      <Disabler
        disabled={props.disabled}
        tooltipText={t('automaions.wizard.actions.email.disabled.tooltip')}
      >
        <SimpleFlexContainer $row>
          <WideSpan>
            <Select
              placeholder={t(
                'automaions.wizard.actions.email.recipient.placeholder'
              )}
              allowMultiSelect
              fullWidth={true}
              value={props.typesOfRecipient}
              options={[
                {
                  text: t(
                    'automaions.wizard.actions.email.recipient.assignedUser'
                  ),
                  value: 'assignedUser',
                  'data-testid': 'send-email-2-assigned-user'
                },
                {
                  text: t(
                    'automaions.wizard.actions.email.recipient.specificUser'
                  ),
                  value: 'specificUser',
                  'data-testid': 'send-email-2-specific-user'
                },
                {
                  value: 'user_from_field',
                  'data-testid': 'user_from_field',
                  text: t('automaions.wizard.actions.share.user_from_field')
                },
                {
                  value: 'user_from_lookup',
                  'data-testid': 'user_from_lookup',
                  text: t('automaions.wizard.actions.share.user_from_lookup')
                }
              ]}
              onChange={props.onTypesOfRecipientChange}
            />
          </WideSpan>

          <EditTemplateBtnContainer>
            <Tooltip title={t('automaions.wizard.actions.email.template.edit')}>
              <IconButton
                size="small"
                onClick={() => props.setIsEmailDialogOpen(true)}
              >
                <EditEmailIcon
                  $playAnimation={props.playIconAttentionAnimation}
                />
              </IconButton>
            </Tooltip>
          </EditTemplateBtnContainer>
        </SimpleFlexContainer>
        {/* <Animation type="collapse">
        <SelectTemplateRowContainer $row>
          <Select
            customCSS="flex: 1;"
            variant={props.variant}
            placeholder={t(
              'automaions.wizard.actions.email.template.placeholder'
            )}
            options={props.emailTemplatesOptions}
          />
          <span>
            <Tooltip title={t('automaions.wizard.actions.email.template.edit')}>
              <IconButton size="small">
                <CreateIcon />
              </IconButton>
            </Tooltip>
          </span>
        </SelectTemplateRowContainer>
      </Animation> */}

        <UsersSelectContainer>
          <Animation
            mountOnEnter
            unmountOnExit
            type="collapse"
            in={props.showUserSelectionDD}
          >
            {/* <Select
            variant={props.variant}
            searchable
            allowMultiSelect
            placeholder={t(
              'automaions.wizard.actions.email.recipient.placeholder'
            )}
            asyncOptions={props.getSelectUsersOptions}
            valueParser={val => (val.value ? val.value : val)}
            openMenuOptionParser={opt => {
              return (
                <p style={{ margin: 0 }}>
                  {opt.value.data.firstName + ' ' + opt.value.data.lastName}
                  <br />
                  <small>{opt.value.data.email}</small>
                </p>
              );
            }}
          /> */}
            <Labeler
              label={t('automaions.wizard.actions.share.specific_user.label')}
            >
              <UsersInputBoxEngine
                value={props.specificUsers}
                onChange={props.onUsersSelectChange}
                customCSS={userSelectCSS}
                placeholder={t(
                  'automaions.wizard.actions.email.recipient.specificUser.placeholder'
                )}
              />
            </Labeler>
          </Animation>
        </UsersSelectContainer>
        <Animation type="collapse" in={props.showEmailFields}>
          <Tooltip
            arrow
            title={
              !props.emailFields || !props.emailFields.length
                ? 'Please add email field'
                : ''
            }
          >
            <Labeler
              label={t('automaions.wizard.actions.share.email.field.label')}
            >
              <Select
                disabled={!props.emailFields || !props.emailFields.length}
                variant={props.variant}
                fullWidth={true}
                placeholder={t(
                  'automaions.wizard.actions.share.select_user_from_field'
                )}
                customCSS="width: 100% !important;"
                value={props.emailFieldId}
                onChange={props.onChooseUserEmailChange}
                options={props.emailFields.map(f => ({
                  value: f.internalId,
                  text: f.title || 'Untitled user field',
                  'data-testid': `field-${f.internalId}`
                }))}
              />
            </Labeler>
          </Tooltip>
        </Animation>
        <Animation
          mountOnEnter
          unmountOnExit
          type="collapse"
          in={props.showEmailFromLookup}
        >
          <SimpleFlexContainer $column>
            <Labeler
              label={t('automaions.wizard.actions.share.user_lookup.label')}
            >
              <UserLookupFieldSelectEngine
                {...props}
                update={props.onUpdateSelectUsersEngine}
                customCSS="margin-left: 0"
                fullWidth={true}
              />
            </Labeler>
            <StyledTextString>
              Share the submission with this user to grant them access
            </StyledTextString>
          </SimpleFlexContainer>
        </Animation>

        <EmailDialogEngine
          open={props.isEmailDialogOpen}
          handleClose={props.onEmailDialogClosed}
          type={EMAIL_DIALOG_TYPES.TEMPLATE}
          templateId={props.templateIdDDValue}
          allowNewTemplateCreation
          setTemplateId={props.onTemplateSaved}
          topEndPoint={
            <Labeler
              label={t('automaions.wizard.actions.email.template.label')}
            >
              <Select
                value={props.templateIdDDValue}
                onChange={props.setTemplateIdDDValue}
                fullWidth
                variant={props.variant}
                placeholder={t(
                  'automaions.wizard.actions.email.template.placeholder'
                )}
                options={props.emailTemplatesOptions}
                customCSS="height: 44px;"
              />
              <Divider />
            </Labeler>
          }
          reducerListener={props.onEmailReducerChange}
          additionalPlaceHolders={props.fieldPlaceHolders}
          additionalPlaceHoldersProps={{
            placeholder: 'Insert field placeholder'
          }}
          additionalSaveTemplateBodyParams={{
            assetType: 'automations'
          }}
          forceNewTemplateCreation={props.forceTemplateCreation}
        />
      </Disabler>
    </Container>
  );
};

export default EmailConfView;
